import { PROFILE } from "../data/work";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-line px-5 md:px-12 py-10 max-w-[1600px] mx-auto"
    >
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-sm text-muted2">
        <p className="font-serif text-lg text-ink">
          Srishti Agarwal<span className="text-vermilion">.</span>
        </p>
        <p className="uppercase tracking-[0.15em]">{PROFILE.location}</p>
        <p>© {year}, Built with words that work.</p>
      </div>
    </footer>
  );
}
